module.exports = __webpack_public_path__ + "2d499ab556d929865f461acb8f2a13bf.svg";